import { Platform } from "@angular/cdk/platform";
import { DOCUMENT } from "@angular/common";
import { AfterViewInit, Component, ElementRef, HostBinding, Inject, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { Subscription } from "rxjs";
import { ISettingsApp } from "../core/models/settings-app";
import { AuthService } from "../core/services/auth/auth.service";
import { ConfigService } from "../core/services/config.service";

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppMainComponent implements OnDestroy {

    public onSettingsChanged!: Subscription;
    public appSettings: ISettingsApp = {
        layout: {
          navigation: 'none',
          navigationFolded: false,
          toolbar: 'none',
          footer: 'none',
          mode: 'fullwidth'
        },
        colorClasses: {
          toolbar: 'mat-white-500-bg',
          navbar: 'mat-app-900-bg',
          footer: 'mat-fuse-dark-900-bg'
        },
        customScrollbars: true,
        routerAnimation: 'fadeIn'
    };
    @HostBinding('attr.app-layout-mode') layoutMode: any;

    constructor(
        private readonly render: Renderer2,
        private readonly elementRef: ElementRef,
        private readonly appConfig: ConfigService,
        private readonly platform: Platform,
        private readonly authServer: AuthService,
        @Inject(DOCUMENT) private document: any
    ) {
        this.onSettingsChanged = this.appConfig.onSettingsChanged.subscribe((newSettings) => {
            this.appSettings = newSettings;
            this.layoutMode = this.appSettings.layout.mode;
        });

        if (this.platform.ANDROID || this.platform.IOS) {
            this.document.body.className += ' is-mobile';
        }
    }

    ngOnDestroy(): void {
        this.onSettingsChanged.unsubscribe();
    }

    public addClass(className: string): void {
        this.render.addClass(this.elementRef.nativeElement, className);
    }

    public removeClass(className: string): void {
        this.render.removeClass(this.elementRef.nativeElement, className);
    }

    public get rol(): string {
        var label = this.authServer.rolCode;

        switch(this.authServer.rolCode) {
            case 'owner':
            case 'both':
                label = 'owner';
            break;
        }

        return label;
    }

    public get isLogged(): boolean {
        return this.authServer.isAuthenticated();
    }
}